export default "__VITE_ASSET__f3a9d926__$_?nuxt_component=async__"